export default {
  allShowedOverlays: [],
  popupData: null,
  titlePopup: null,
  buttonPopup: null,
  contentReview: {},
};
